<script>
export default {
  name: "AnkhList",
  props: {
    showBtnGroup: {
      type: Boolean,
      default: true,
    },
    showSearchForm: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: Number,
      default: 20,
    },
    // 外部元素高度
    externalHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      wrapperHeight: 0,
      tableHeight: 0,
      content: 0
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    // 监听窗口大小变化
    handleResize() {
      this.handleResizeListHeight();
      this.$nextTick(() => {
        this.handleResizeTableHeight();
      })
    },

    // 监听列表容器高度
    handleResizeListHeight() {
      const wrapper = document.querySelector(".tv-main-body");
      this.wrapperHeight = wrapper.clientHeight - (40 + this.externalHeight);
    },

    // 监听表格内容高度
    handleResizeTableHeight() {
      const wrapper = document.querySelector("#table-content");
      this.tableHeight = wrapper.clientHeight;
    },

  },
  watch: {
    externalHeight: {
      handler() {
        this.$nextTick(() => {
          this.handleResize();
        })
      },
      immediate: true,
    }

  }
}
</script>

<template>
  <div class="wrapper" :style="{height: wrapperHeight + 'px'}">
    <!--  按钮区  -->
    <el-form inline class="btn-group" size="small" v-if="showBtnGroup">
      <el-form-item style="margin: 0 0 10px">
        <slot name="btn-group">
          <el-button>{{ $t("批量删除") }}</el-button>
          <el-button>{{ $t("批量禁用用户") }}</el-button>
        </slot>
      </el-form-item>
    </el-form>

    <!-- 内容区   -->
    <div class="content" :style="{padding: padding + 'px'}">
      <slot name="form-header" v-if="$slots['form-header']"></slot>

      <!-- 表单区   -->
      <el-form class="search-form" inline size="small" v-if="showSearchForm">
        <slot name="search-form">
          <el-form-item :label="$t('编号')" v-for="item in 10" :key="item">
            <el-input :placeholder="$t('请输入编号')" />
          </el-form-item>
        </slot>
      </el-form>

      <slot name="tab-row" v-if="$slots['tab-row']"></slot>

      <!-- 表格区域  -->
      <div class="table-content" id="table-content">
        <div class="table-content-box">
          <slot name="table" :height="tableHeight"></slot>
        </div>
      </div>
    </div>

    <!-- 弹窗区 -->
    <slot name="other"></slot>
  </div>
</template>

<style scoped>

.wrapper {
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  background: #ffffff;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.table-content {
  flex: 1;
  position: relative;
}

.table-content-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}


</style>
